// O backend às vezes grava o nome do médico já com o honorífico embutido
// (ex.: "Dra Ana Souza"). Ao exibir, precisamos remover esse prefixo para não
// duplicá-lo (ex.: "Dr(a). Dra Ana Souza"). Só remove quando há um separador
// depois do honorífico, para não mutilar nomes como "Drauzio".
const stripHonorific = name => {
  if (!name) return "";
  return String(name)
    .trim()
    .replace(/^dr\s*\(?a?\)?\.?\s+/i, "");
};

export { stripHonorific };
